import React, { ReactElement, useRef } from 'react';

import RCSelect from 'rc-select';

import { SELECT_CONTAINER_CLASS, SELECT_CONTAINER_ERROR_CLASS } from '../../utils/constants';
import { ArrowIcon, ClearIcon, RemoveIcon, SelectedIcon } from './components/Icons/Icons';
import * as Styled from './Select.styles';
import { ISelectProps } from './Select.types';

const Select = <T extends unknown>({
  className = '',
  disabled = false,
  placeholder,
  mode = 'single',
  children,
  showSearch = true,
  invalid = false,
  hasError = false,
  size = 'medium',
  ...rest
}: ISelectProps<T>): ReactElement => {
  const container = useRef<HTMLDivElement | null>(null);

  return (
    <Styled.Select prefixCls={SELECT_CONTAINER_CLASS} ref={container} size={size} className={className}>
      <RCSelect<T>
        className={invalid || hasError ? SELECT_CONTAINER_ERROR_CLASS : undefined}
        prefixCls={SELECT_CONTAINER_CLASS}
        getPopupContainer={() => container.current as HTMLElement}
        inputIcon={ArrowIcon}
        placeholder={placeholder}
        disabled={disabled}
        menuItemSelectedIcon={SelectedIcon}
        clearIcon={ClearIcon}
        removeIcon={RemoveIcon}
        mode={mode !== 'single' ? mode : undefined}
        showSearch={showSearch}
        showArrow
        allowClear={mode === 'single'}
        optionFilterProp="children"
        optionLabelProp="children"
        {...rest}
      >
        {children}
      </RCSelect>
    </Styled.Select>
  );
};

export default Select;
